import axios from './axiosInterceptors';

const API_URL = "/api/v1/core/";

const dropdownItems = (dropdowns) => {
    return axios
        .post(API_URL + "dropdowns",
            dropdowns).then((response) => {
                return response.data;
            })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};
const isLogged = () => {
    return axios.get("/api/v1/login/is-logged");
};

const allActions = {
    dropdownItems,
    isLogged
};

export default allActions;